// extracted by mini-css-extract-plugin
export default {"richTextEditor":"language-editors_richTextEditor__JkXHP","editorsWrapper":"language-editors_editorsWrapper__BM+Yh"};